export default __webpack_public_path__ + "assets/payment-icons/unionpay.201f13f9a6f2e8342e821af5780d1c1b.svg";